<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol>
        <loader v-show="loading" />
        <CCardGroup>
          <CCard>
            <CCardBody>
              <CForm v-on:submit.prevent="login">
                <h1>Login</h1>
                <p class="text-muted">Sign In to your account</p>
                <CInput
                  placeholder="Username"
                  autocomplete="username email"
                  v-model="loginData.email"
                >
                  <template #prepend-content>
                    <CIcon name="cil-user" />
                  </template>
                </CInput>
                <CInput
                  placeholder="Password"
                  type="password"
                  autocomplete="curent-password"
                  v-model="loginData.password"
                >
                  <template #prepend-content>
                    <CIcon name="cil-lock-locked" />
                  </template>
                </CInput>
                <CRow>
                  <CCol col="6" class="text-left">
                    <CButton type="submit" color="primary" class="px-4"
                      >Login</CButton
                    >
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import { HTTP } from "../../lib/httplib";
import Loader from "../../components/Loader";
export default {
  components: {
    Loader
  },
  name: "Login",
  data () {
    return {
      loading: false,
      loginData: {}
    };
  },
  methods: {
    login () {
      this.loading = true;
      HTTP.post("/api/auth/login", this.loginData)
        .then(res => {
          console.log(res.data, 'login-berhasil')
          this.$cookie.set("larapos", JSON.stringify(res.data.data));
          setTimeout(function () {
            window.location.href = "/";
            this.loading = false;
          }, 1000);
        })
        .catch(eres => {
          if (
            eres.response &&
            eres.response.data &&
            eres.response.data.error == "Unauthorized"
          ) {
            this.loading = false;
            this.$toasted
              .error("Username dan password tidak cocok")
              .goAway(3000);
          } else {
            if (eres && eres.response && eres.response.data && eres.response.data.user_message) {
              this.$toasted.error(eres.response.data.user_message).goAway(3000)
              this.loading = false;
              return;
            }
            this.$toasted.error("Server bermasalah").goAway(3000);
            this.loading = false;
          }
        });
    }
  }
};
</script>
